import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1)
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "modal-card-head" }
const _hoisted_4 = { class: "modal-card-title mb-0" }
const _hoisted_5 = { class: "modal-card-body" }
const _hoisted_6 = {
  key: 0,
  class: "modal-card-foot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SButton = _resolveComponent("SButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal", {
			'is-active': _ctx.show
		}])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _createVNode(_component_SButton, {
          class: "delete",
          "aria-label": "close",
          color: "dark",
          onClick: _ctx.onClose
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("section", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (!_ctx.withoutFooter)
        ? (_openBlock(), _createElementBlock("footer", _hoisted_6, [
            _createVNode(_component_SButton, {
              "button-text": "Save changes",
              color: "link",
              type: "submit",
              onClick: _ctx.onSubmit
            }, null, 8, ["onClick"]),
            _createVNode(_component_SButton, {
              "button-text": "Cancel",
              onClick: _ctx.onClose
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}